export default __webpack_public_path__ + "static/illu_five-61b0be49fc68e35e263707647c89146e.png";